import { For, Show } from 'solid-js'
import { openBrowse } from '../store/view.ts'
import { cn } from '../utils/cn.ts'

/* every segment is a link to that directory, which is what makes walking back up a
   tree possible without a dedicated "parent" button */
export function PathBreadcrumb(props: { repo: string, path: string, class?: string }) {
  const segments = () => props.path.split('/').filter(Boolean)

  return (
    <div class={cn('flex min-w-0 items-center gap-1 text-xs font-mono', props.class)}>
      <span
        class="shrink-0 cursor-pointer text-muted-foreground hover:text-foreground hover:underline"
        onClick={() => openBrowse(props.repo)}
      >
        {props.repo}
      </span>
      <For each={segments()}>
        {(segment, i) => {
          const isLast = () => i() === segments().length - 1
          const upTo = () => segments().slice(0, i() + 1).join('/')

          return (
            <>
              <span class="shrink-0 text-muted-foreground">/</span>
              <Show
                when={!isLast()}
                fallback={<span class="truncate font-medium">{segment}</span>}
              >
                <span
                  class="shrink-0 cursor-pointer text-muted-foreground hover:text-foreground hover:underline"
                  onClick={() => openBrowse(props.repo, upTo())}
                >
                  {segment}
                </span>
              </Show>
            </>
          )
        }}
      </For>
    </div>
  )
}
